import { combineReducers } from 'redux';

import accordionState from './accordionState';
import postActivationState from './postActivationState';
import properties from './properties';
import currentProperty from './currentProperty';
import propertiesFilters from './propertiesFilters';
import propertyConversion from './propertyConversion';
import propertyOverview from './propertyOverview';
import recommendations from './recommendations';

const rootPropertiesReducer = combineReducers({
  accordionState,
  properties,
  currentProperty,
  postActivationState,
  propertiesFilters,
  propertyConversion,
  propertyOverview,
  recommendations,
});

export default rootPropertiesReducer;
